var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSticker = function SvgIconSticker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.75 21.25h-4.5a5.5 5.5 0 0 1-5.5-5.5v-7.5a5.5 5.5 0 0 1 5.5-5.5h7.5a5.5 5.5 0 0 1 5.5 5.5v4.5q0 .18-.06.342c-.242.71-.736 1.506-1.312 2.274a23 23 0 0 1-2.108 2.404 23 23 0 0 1-2.404 2.108c-.768.576-1.564 1.07-2.274 1.312a1 1 0 0 1-.342.06M5.775 5.775A3.5 3.5 0 0 1 8.25 4.75h7.5a3.5 3.5 0 0 1 3.5 3.5v3.5h-2a5.5 5.5 0 0 0-5.5 5.5v2h-3.5a3.5 3.5 0 0 1-3.5-3.5v-7.5a3.5 3.5 0 0 1 1.025-2.475m12.803 7.975q-.138.2-.3.416c-.529.705-1.2 1.466-1.923 2.19a21 21 0 0 1-2.19 1.922q-.215.162-.415.3V17.25a3.5 3.5 0 0 1 3.5-3.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSticker;